import MultiImageBanner from './MultiImageBanner';

export default MultiImageBanner;
